import React from "react";
import {
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: "100%",
  },
}));

const THEME = createMuiTheme({
  typography: {
    fontFamily: `'Open Sans', sans-serif`,
    fontWeight: 200,
  },
});

export default function DropDownComponent({ menuItems, setOption }) {
  const classes = useStyles();
  const [selected, setSelected] = React.useState(
    menuItems.length ? menuItems[0]["value"] : ""
  );
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    setOption(value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <MuiThemeProvider theme={THEME}>
      <FormControl className={classes.formControl}>
        <Select
          className={classes.select}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={selected}
          onChange={handleChange}
        >
          {menuItems.map((item) => (
            <MenuItem key={item["value"]} value={item["value"]}>
              {item["display"]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </MuiThemeProvider>
  );
}
